import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => {
        return localStorage.getItem("ls39_lang") || "es";
    });

    useEffect(() => {
        localStorage.setItem("ls39_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = translations[lang];
    const toggle = () => setLang((p) => (p === "es" ? "en" : "es"));

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LanguageContext.Provider>
    );
}

export function useLang() {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
    return ctx;
}
